import { useCallback, useEffect, useMemo, useState } from "react";
import http from "services/httpService";

function useFetchWellness(fetchPermitted) {
  const getInitialVendors = () => {
    try {
      return JSON.parse(localStorage.getItem("vendors"));
    } catch (err) {
      return [];
    }
  };

  const [benefits, setBenefits] = useState([]);
  const [vendors, setVendors] = useState(getInitialVendors);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (fetchPermitted) {
      try {
        Promise.all([getBenefits(), getVendors()]);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    }
  }, []);

  const saveBenefit = useCallback(async (values) => {
    const payload = [];
    if (values?.grades?.length > 0) {
      values?.grades.forEach((grade, index) => {
        payload.push({
          ...grade,
          vendor_id: values?.vendor_id,
          benefit_id: Number(values?.benefit_id),
          grade_code: values?.gmcGradeCodes[index]
        })
      })
    } else {
      const { choiceType, gmcGradeCodes, grades, ...updatedValues } = values;
      payload[0] = {
        ...updatedValues,
        benefit_id: Number(values?.benefit_id),
      };
    }
    console.log({payload})
    try {
      const { data } = http.post("/business/save_plan_benefit_data/", payload);
      console.log({ data });
    } catch (err) {
      console.error(err);
    }

    console.log("SAVE", { payload });
  }, []);

  const getBenefitMapping = async () => {
    try {
      const { data } = await http.get("/business/get_benefit_mapping/");
      return data;
    } catch (err) {
      console.error(err);
    }
  };

  const getPlanBenefitData = useCallback(async (benefit_id) => {
    if(!benefit_id) return;
    const { data } = await http.get("/business/get_plan_benefit_data/", {
      params: {
        benefit_id,
      },
    });
    return data;
  }, []);

  const getBenefits = async () => {
    try {
      const { data } = await http.get("/benefits/get_benefit_list/");
      setBenefits(data);
      localStorage.setItem("benefits", JSON.stringify(data));
    } catch (err) {
      console.error(err);
    }
  };

  const getVendors = async () => {
    try {
      const { data } = await http.get("/benefits/get_vendor_summary/");
      setVendors(data);
      localStorage.setItem("vendors", JSON.stringify(data));
    } catch (err) {
      console.error(err);
    }
  };

  const vendorOptions = useMemo(() => {
    if (!vendors) return [];
    return vendors.map(({ name, id }) => ({
      label: name,
      value: id,
    }));
  }, [vendors]);

  const locallySaveBenefitsVendor = (data) => {
    if (!data) return;
    localStorage.setItem("wellness", JSON.stringify(data));
    return true;
  };

  const getLocalVendors = () => {
    const vendors = localStorage.getItem("vendors");
    try {
      return JSON.parse(vendors);
    } catch (err) {
      return null;
    }
  };

  const getLocalBenefits = () => {
    const benefits = localStorage.getItem("benefits");
    try {
      return JSON.parse(benefits);
    } catch (err) {
      return null;
    }
  };

  const getSelectedWellness = () => {
    const wellness = localStorage.getItem("wellness");
    try {
      const wellnessJSON = JSON.parse(wellness);
      return wellnessJSON?.selectedBenefits;
    } catch (err) {
      return null;
    }
  };

  const getGmcGradeCodes = async () => {
    try {
      const { data } = await http.get("/business/get_gmc_grade_codes/");
      return data;
    } catch (err) {
      return null;
    }
  };

  const mapWellnessBenefit = async (payload) => {
    try {
      await http.post("/business/map_wellness_benefits/", payload);
    } catch (err) {
      console.error(err);
    }
  };

  return {
    benefits,
    vendors,
    vendorOptions,
    loading,
    locallySaveBenefitsVendor,
    getLocalVendors,
    getLocalBenefits,
    getSelectedWellness,
    getGmcGradeCodes,
    getBenefitMapping,
    mapWellnessBenefit,
    saveBenefit,
    getPlanBenefitData
  };
}

export default useFetchWellness;
